import React from 'react';
import { TestCollection } from '@components/testcollection/TestCollection';
import { RelatedArticleType } from '@appTypes/articleType';

interface Props {
  value: { testscores: RelatedArticleType[] };
}
export const TestCollectionBlock = ({ value: { testscores } }: Props) => <TestCollection testCollection={testscores} />;
